import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Box } from "@mui/material"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import FormControlLabel from "@mui/material/FormControlLabel"
import Checkbox from "@mui/material/Checkbox"
import Radio from "@mui/material/Radio"
import RadioGroup from "@mui/material/RadioGroup"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import { ULoading, UTextField } from "@/components/index"
import { UText } from "@/components/index"
import Slider from "@mui/material/Slider"
import bridgeFilling from "@/assets/svgs/bridgeFilling.svg"
import { set } from "react-hook-form"
import { GlobalEvents, globalEvents, wasmModule } from "@/gluelayer"
import Divider from "@mui/material/Divider"

const defaultSliderValues = {
  buccal: 30,
  lingual: 30,
  top: 20,
  A: 50,
  B: 50,
  C: 60,
  D: 60,
}
export const SliderBox = ({ tabIndex, curTabIndex, archType }) => {
  const dispatch = useAppDispatch()

  const [curJsonData, setCurJsonData] = useState<any>(null)

  const [checkNoFilling, setCheckNoFilling] = useState<boolean>(false)
  const [checkNoBridge, setCheckNoBridge] = useState<boolean>(false)
  const handleCheckNoFilling = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checkedState = event.target.checked

    setCheckNoFilling(checkedState)
    resetCheckNoFilling(checkedState)

    // 更新 jsondata 中的 NoGenerateUndercut 字段
    const newdata = { ...curJsonData }
    newdata.NoGenerateUndercut = checkedState
    newdata.undercutParams = {
      buccalWidth: checkedState ? 0 : defaultSliderValues.buccal / 100,
      lingualWidth: checkedState ? 0 : defaultSliderValues.lingual / 100,
      topHeight: checkedState ? 0 : defaultSliderValues.top / 100,
    }

    setCurJsonData(newdata)
    setUndercutValueToWasm(newdata)
  }
  const handleCheckNoBridge = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checkedState = event.target.checked

    setCheckNoBridge(checkedState)
    resetBridgeSliders(checkedState)

    // 更新 jsondata 中的 NoGenerateBridge 字段
    const newdata = { ...curJsonData }
    newdata.NoGenerateBridge = checkedState
    newdata.bridgeParams = {
      bridgeBuccalBottomWidth: checkedState ? 0 : defaultSliderValues.A / 100,
      bridgeLingualBottomWidth: checkedState ? 0 : defaultSliderValues.B / 100,
      bridgeMesialHeight: checkedState ? 0 : defaultSliderValues.C / 100,
      bridgeDistalHeight: checkedState ? 0 : defaultSliderValues.D / 100,
    }

    setCurJsonData(newdata)
    setUndercutValueToWasm(newdata)
  }

  // reset checkNoFilling  sliders values to default
  const resetCheckNoFilling = (isChecked: boolean) => {
    setBuccalVal(isChecked ? 0 : defaultSliderValues.buccal)
    setLingualVal(isChecked ? 0 : defaultSliderValues.lingual)
    setTopVal(isChecked ? 0 : defaultSliderValues.top)
  }

  // reset bridge sliders values to default
  const resetBridgeSliders = (isChecked: boolean) => {
    setAVal(isChecked ? 0 : defaultSliderValues.A)
    setBVal(isChecked ? 0 : defaultSliderValues.B)
    setCVal(isChecked ? 0 : defaultSliderValues.C)
    setDVal(isChecked ? 0 : defaultSliderValues.D)
  }

  //SetUndercutValue
  const setUndercutValueToWasm = (jsonstrdata) => {
    setIsloading(true)

    setTimeout(() => {
      const newJsonStrData = JSON.stringify(jsonstrdata)
      console.log("newJsonStrData:" + newJsonStrData)
      //SetUndercutValue(std::string strJson, int tabIndex, int archType)
      const printModule = wasmModule.moduleManager.GetModulePrintSelection()
      if (!printModule) {
        console.error("Print module not found")
        setIsloading(false)
        return
      }
      printModule.SetUndercutValue(newJsonStrData, tabIndex, archType)

      //parse json data
      // const jsonStrData = printModule.GetUndercutValue(tabIndex, archType)
      // parseJsonData(jsonStrData)

      setIsloading(false)
    }, 200)
  }
  // buccal
  const [buccalVal, setBuccalVal] = useState(30)
  const handleChangeBuccal = (event: Event, newValue: number) => {
    setBuccalVal(newValue)
  }
  // Lingual
  const [lingualVal, setLingualVal] = useState(30)
  const handleChangeLingual = (event: Event, newValue: number) => {
    setLingualVal(newValue)
  }
  // Top
  const [topVal, setTopVal] = useState(20)
  const handleChangeTop = (event: Event, newValue: number) => {
    setTopVal(newValue)
  }

  const [AVal, setAVal] = useState(50)
  const handleChangeA = (event: Event, newValue: number) => {
    setAVal(newValue)
  }

  const [BVal, setBVal] = useState(50)
  const handleChangeB = (event: Event, newValue: number) => {
    setBVal(newValue)
  }

  const [CVal, setCVal] = useState(60)
  const handleChangeC = (event: Event, newValue: number) => {
    setCVal(newValue)
  }

  const [DVal, setDVal] = useState(60)
  const handleChangeD = (event: Event, newValue: number) => {
    setDVal(newValue)
  }

  const handleChangeCommited =
    (
      setState: React.Dispatch<React.SetStateAction<number>>,
      keyPath: string[],
    ) =>
    (event: Event, newValue: number) => {
      if (typeof newValue !== "number") return

      setState(newValue)

      // 深拷贝 jsondata，更新对应字段
      const newdata = { ...curJsonData }

      let target = newdata
      for (let i = 0; i < keyPath.length - 1; i++) {
        target[keyPath[i]] = { ...target[keyPath[i]] }
        target = target[keyPath[i]]
      }

      target[keyPath[keyPath.length - 1]] = newValue / 100

      setUndercutValueToWasm(newdata)
      setCurJsonData(newdata)
    }

  const handleChangeCommitedBuccal = handleChangeCommited(setBuccalVal, [
    "undercutParams",
    "buccalWidth",
  ])
  const handleChangeCommitedLingual = handleChangeCommited(setLingualVal, [
    "undercutParams",
    "lingualWidth",
  ])
  const handleChangeCommitedTop = handleChangeCommited(setTopVal, [
    "undercutParams",
    "topHeight",
  ])

  const handleChangeCommitedA = handleChangeCommited(setAVal, [
    "bridgeParams",
    "bridgeBuccalBottomWidth",
  ])
  const handleChangeCommitedB = handleChangeCommited(setBVal, [
    "bridgeParams",
    "bridgeLingualBottomWidth",
  ])
  const handleChangeCommitedC = handleChangeCommited(setCVal, [
    "bridgeParams",
    "bridgeMesialHeight",
  ])
  const handleChangeCommitedD = handleChangeCommited(setDVal, [
    "bridgeParams",
    "bridgeDistalHeight",
  ])

  const [isloading, setIsloading] = useState(false)
  const [fillingExist, setFillingExist] = useState(false)
  const [bridgeExist, setBridgeExist] = useState(false)

  const parseJsonData = (jsonStrData) => {
    let parsed: any
    try {
      parsed =
        typeof jsonStrData === "string" ? JSON.parse(jsonStrData) : jsonStrData
    } catch (error) {
      console.error("解析 JSON 失败:", error)
      return
    }

    const {
      bridgeParams,
      undercutParams,
      NoGenerateBridge,
      NoGenerateUndercut,
    } = parsed

    if (typeof NoGenerateUndercut === "boolean") {
      setCheckNoFilling(NoGenerateUndercut)

      if (NoGenerateUndercut) resetCheckNoFilling(true)
      else {
        setBuccalVal(undercutParams.buccalWidth * 100)
        setLingualVal(undercutParams.lingualWidth * 100)
        setTopVal(undercutParams.topHeight * 100)
      }
    }
    if (typeof NoGenerateBridge === "boolean") {
      setCheckNoBridge(NoGenerateBridge)

      if (NoGenerateBridge) resetBridgeSliders(true)
      else {
        setAVal(bridgeParams.bridgeBuccalBottomWidth * 100)
        setBVal(bridgeParams.bridgeLingualBottomWidth * 100)
        setCVal(bridgeParams.bridgeMesialHeight * 100)
        setDVal(bridgeParams.bridgeDistalHeight * 100)
      }
    }

    setCurJsonData(parsed)
  }

  const resetIndividualData = () => {
    setBuccalVal(defaultSliderValues.buccal)
    setLingualVal(defaultSliderValues.lingual)
    setTopVal(defaultSliderValues.top)
    setAVal(defaultSliderValues.A)
    setBVal(defaultSliderValues.B)
    setCVal(defaultSliderValues.C)
    setDVal(defaultSliderValues.D)
    setCheckNoFilling(false)
    setCheckNoBridge(false)
    setFillingExist(false)
    setBridgeExist(false)
  }

  const checkFillingBridgeExist = () => {
    const printModule = wasmModule.moduleManager.GetModulePrintSelection()
    if (!printModule) return
    //GetCurRegionFillingExist(int archType,int tabIndex,int uB)//tab index 0,Ant,1Post,2Single uB 0 Undercut 1 Bridge
    const fillingExist = printModule.GetCurRegionFillingExist(
      archType,
      tabIndex,
      0, // 0 for Undercut
    )
    console.log("🚀 ~ checkFillingBridgeExist ~ fillingExist:", fillingExist)
    setFillingExist(fillingExist)

    const bridgeExist = printModule.GetCurRegionFillingExist(
      archType,
      tabIndex,
      1, // 1 for Bridge
    )
    console.log("🚀 ~ checkFillingBridgeExist ~ bridgeExist:", bridgeExist)
    setBridgeExist(bridgeExist)
  }

  useEffect(() => {
    if (curTabIndex !== tabIndex) return

    if (tabIndex === 2) resetIndividualData()
    else {
      checkFillingBridgeExist()

      const printModule = wasmModule.moduleManager.GetModulePrintSelection()
      if (!printModule) return
      const jsonStrData = printModule.GetUndercutValue(tabIndex, archType)
      console.log("🚀 ~ jsonStrData:", jsonStrData)
      parseJsonData(jsonStrData)
    }
  }, [archType, curTabIndex])

  useEffect(() => {
    if (tabIndex === 2) {
      const handler = () => {
        console.log("ON_UBRefreshUICBStr event received archType:", archType)
        checkFillingBridgeExist()
        const printModule = wasmModule.moduleManager.GetModulePrintSelection()
        if (!printModule) return
        const jsonStrData = printModule.GetUndercutValue(2, archType)
        parseJsonData(jsonStrData)
      }

      const cancleSelectHandler = () => {
        console.log("ON_UBHandleCancleSelectCBStr event received")
        resetIndividualData()
      }

      globalEvents.on(GlobalEvents.ON_UBRefreshUICBStr, handler)

      globalEvents.on(
        GlobalEvents.ON_UBHandleCancleSelectCBStr,
        cancleSelectHandler,
      )

      return () => {
        globalEvents.off(GlobalEvents.ON_UBRefreshUICBStr, handler)
        globalEvents.off(
          GlobalEvents.ON_UBHandleCancleSelectCBStr,
          cancleSelectHandler,
        )
      }
    }
  }, [archType, tabIndex])

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          width: "100%",
          borderRadius: "10px",
          background: "#fff",
          margin: "20px 0",
          padding: "0px 20px 10px 0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: "12px",
                height: "12px",
                // borderRadius: "6px",
                background: "#F00",
                marginRight: "8px",
              }}
            ></Box>
            <UText variant={"subtitle1"}>{`Interproxima Filling`}</UText>
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={checkNoFilling}
                onChange={handleCheckNoFilling}
                disabled={!fillingExist}
              />
            }
            label="No Filling"
            sx={{ marginLeft: "40px" }}
          />
        </Box>
        <Box sx={{ display: "flex", marginLeft: "0px" }}>
          <Box className={"leftRight"} sx={{ width: "50%" }}>
            <Box className={"top"} sx={{ display: "flex" }}>
              <UText
                variant={"subtitle1"}
                sxProp={{ width: "110px", textAlign: "right" }}
              >{`Buccal`}</UText>
              <Slider
                sx={{ margin: "0 20px", width: "60%" }}
                value={buccalVal}
                disabled={checkNoFilling || !fillingExist}
                onChange={handleChangeBuccal}
                onChangeCommitted={handleChangeCommitedBuccal}
              />
            </Box>
            <Box className={"bottom"} sx={{ display: "flex" }}>
              <UText
                variant={"subtitle1"}
                sxProp={{ width: "110px", textAlign: "right" }}
              >{`Lingual`}</UText>
              <Slider
                sx={{ margin: "0 20px", width: "60%" }}
                value={lingualVal}
                disabled={checkNoFilling || !fillingExist}
                onChange={handleChangeLingual}
                onChangeCommitted={handleChangeCommitedLingual}
              />
            </Box>
          </Box>
          <Box className={"leftRight"} sx={{ width: "50%" }}>
            <Box className={"top"} sx={{ display: "flex" }}>
              <UText
                variant={"subtitle1"}
                sxProp={{ width: "110px", textAlign: "right" }}
              >{`Top`}</UText>
              <Slider
                sx={{ margin: "0 20px", width: "60%" }}
                value={topVal}
                disabled={checkNoFilling || !fillingExist}
                onChange={handleChangeTop}
                onChangeCommitted={handleChangeCommitedTop}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <Divider />
      <Box
        sx={{
          width: "100%",
          borderRadius: "10px",
          background: "#fff",
          padding: "10px 20px 10px 0px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Box
              sx={{
                width: "12px",
                height: "12px",
                background: "#00BB00",
                marginRight: "8px",
              }}
            ></Box>
            <UText variant={"subtitle1"}>{`Bridge Filling`}</UText>
          </Box>

          {/* png */}
          {/* <img src={bridgeFilling} style={{ marginLeft: "30px" }} /> */}
          <FormControlLabel
            control={
              <Checkbox
                checked={checkNoBridge}
                onChange={handleCheckNoBridge}
                disabled={!bridgeExist}
              />
            }
            label="No Bridge"
            sx={{ marginLeft: "40px" }}
          />
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box className={"leftRight"} sx={{ width: "50%" }}>
            <Box className={"top"} sx={{ display: "flex" }}>
              <UText
                variant={"subtitle1"}
                sxProp={{ width: "110px", textAlign: "right" }}
              >{`Buccal Width`}</UText>
              <Slider
                sx={{ margin: "0 20px", width: "60%" }}
                value={AVal}
                disabled={checkNoBridge || !bridgeExist}
                onChange={handleChangeA}
                onChangeCommitted={handleChangeCommitedA}
              />
            </Box>
            <Box className={"bottom"} sx={{ display: "flex" }}>
              <UText
                variant={"subtitle1"}
                sxProp={{ width: "110px", textAlign: "right" }}
              >{`Mesial Height`}</UText>
              <Slider
                sx={{ margin: "0 20px", width: "60%" }}
                value={CVal}
                disabled={checkNoBridge || !bridgeExist}
                onChange={handleChangeC}
                onChangeCommitted={handleChangeCommitedC}
              />
            </Box>
          </Box>
          <Box className={"leftRight"} sx={{ width: "50%" }}>
            <Box className={"top"} sx={{ display: "flex" }}>
              <UText
                variant={"subtitle1"}
                sxProp={{ width: "110px", textAlign: "right" }}
              >{`Lingual Width`}</UText>
              <Slider
                sx={{ margin: "0 20px", width: "60%" }}
                value={BVal}
                disabled={checkNoBridge || !bridgeExist}
                onChange={handleChangeB}
                onChangeCommitted={handleChangeCommitedB}
              />
            </Box>
            <Box className={"top"} sx={{ display: "flex" }}>
              <UText
                variant={"subtitle1"}
                sxProp={{ width: "110px", textAlign: "right" }}
              >{`Distal Height`}</UText>
              <Slider
                sx={{ margin: "0 20px", width: "60%" }}
                value={DVal}
                disabled={checkNoBridge || !bridgeExist}
                onChange={handleChangeD}
                onChangeCommitted={handleChangeCommitedD}
              />
            </Box>
          </Box>
        </Box>
      </Box>

      <ULoading isLoading={isloading} />
    </Box>
  )
}
